
document.addEventListener("DOMContentLoaded", function () {
    const button1 = $(".generator__button--small")
    const button2 = $(".generator__button--big")
    button2.hide();

    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (isTouchDevice) {
        return;
    }
    button1.on("mouseenter", () => {
        button1.hide();
        button2.show();
    });

    button2.on("mouseleave", () => {
        button2.hide();
        button1.show();
    });

});

document.addEventListener("DOMContentLoaded", function () {
    const lightbox = document.getElementById("lightbox");
    const lightboxImg = document.getElementById("lightbox-img");
    const closeButton = lightbox.querySelector(".close");

    document.querySelectorAll(".zoom").forEach(el => {
        el.addEventListener("click", function (e) {
            e.stopPropagation();

            const parent = this.closest(".generator__content");
            if (!parent) return;

            const zoomedImg = parent.querySelector(".zoomed");
            if (!zoomedImg) return;

            lightboxImg.src = zoomedImg.src;
            lightbox.style.display = "flex";
        });
    });

    closeButton.addEventListener("click", function (e) {
        e.stopPropagation();
        closeLightbox();
    });

    function closeLightbox () {
        lightbox.style.display = "none";
        lightboxImg.src = "";
    }
});

$(document).ready(function () {
    let isAnimating = false;
    let currentIndex = 0;

    $('.generator__content').not(':first').hide();

    $('.generator__button').on('click',function () {

        if (isAnimating) return;

        isAnimating = true;

        $(this).addClass('spinning');
        const sound = document.querySelector('.tv-sound');
        sound.play();
        $('.generator__content:visible').fadeOut(300, function () {

            $('.generator-gif-container').show();

            setTimeout(function () {
                sound.pause();
                sound.currentTime = 0;
                $('.generator-gif-container').hide();
                $('.generator__button').removeClass('spinning');

                let nextContent = $('.generator__content').eq(currentIndex + 1);
                if (nextContent.length === 0) {
                    nextContent = $('.generator__content').eq(0);
                    currentIndex = 0;
                } else {
                    currentIndex++;
                }

                nextContent.fadeIn(300, function () {
                    isAnimating = false;
                });

            }, 1200);
        });
    });
});


